import { render, staticRenderFns } from "./LicenseStatus.vue?vue&type=template&id=440647c0&"
import script from "./LicenseStatus.vue?vue&type=script&lang=js&"
export * from "./LicenseStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports